import { CreditCardData } from 'design-system';
import { AppThunk } from '../../ThunkTypes';

import { updatePaymentData } from '../slice';

export const setPaymentData =
  (creditCardData: CreditCardData): AppThunk =>
  (dispatch): void => {
    dispatch(updatePaymentData(creditCardData));
  };

export const invalidateCreditCard =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(
      updatePaymentData({
        cardName: '',
        cardNumber: '',
        cardType: '',
        expirationDate: '',
        securityCode: '',
        bankEntityCode: '',
        cardAddress: '',
      }),
    );
  };
